<template>
  <el-dialog title="이력서" :visible.sync="dialogVisible" class="dialog" @close="close">
    <div class="personnelInformation">
      <p class="personnelInformation-text">이름</p>
      <p class="personnelInformation-name">{{ item.name || '' }}</p>
    </div>
    <div class="personnelInformation">
      <p class="personnelInformation-text">성별</p>
      <p class="personnelInformation-name">{{ item.gender || '' }}</p>
    </div>
    <div class="personnelInformation">
      <p class="personnelInformation-text">일당</p>
      <p class="personnelInformation-name">{{ item.money || '' }}</p>
    </div>
    <div class="personnelInformation">
      <p class="personnelInformation-text">도시</p>
      <p class="personnelInformation-name">
        <span v-for="(item,index) in item.talentsCitys" :key="index">
        {{ item.name }},
          <!-- <span v-if="item.talentsCitys && (index + 1 < item.talentsCitys.length)">,</span>-->
      </span>
      </p>
    </div>
    <div class="personnelInformation">
      <p class="personnelInformation-text">근무경력</p>
      <p class="personnelInformation-name">{{ item.exp || '' }}</p>
    </div>
    <div class="personnelInformation">
      <p class="personnelInformation-text">업종</p>
      <p class="personnelInformation-name">
        <span v-for="(item,index) in item.talentsTypes" :key="index">
        {{ item.name }},
          <!--<span v-if="item.talentsIndustry && (index < item.talentsIndustry.length)">,</span>-->
      </span>
      </p>
    </div>
    <div class="personnelInformation">
      <p class="personnelInformation-text">특기</p>
      <p class="personnelInformation-name">{{ item.strong_point || '' }}</p>
    </div>
    <div class="personnelInformation">
      <p class="personnelInformation-text">전화번호</p>
      <p class="personnelInformation-name">{{ item.mobile || '' }}</p>
    </div>
    <div class="personnelInformation">
      <p class="personnelInformation-text">위챗 ID</p>
      <p class="personnelInformation-name">{{ item.wechat_code || '' }}</p>
    </div>
    <div class="personnelInformation">
      <p class="personnelInformation-text">카톡 ID</p>
      <p class="personnelInformation-name">{{ item.kato || '' }}</p>
    </div>
    <div class="personnelInformation">
      <p class="personnelInformation-text">이메일</p>
      <p class="personnelInformation-name">{{ item.email || '' }}</p>
    </div>
    <div class="personnelInformation">
      <p class="personnelInformation-text">자기소개</p>
      <p class="personnelInformation-name">{{ item.sketch || '' }}</p>
    </div>
    <div class="htmlContent" v-html="item.detail">
      <!--      <el-image
                class="personnelInformation-image"
                :src="url"
                fit="fill"/>-->
    </div>
  </el-dialog>
</template>
<script>
export default {
  name: "su-dialog",
  props: {
    item: {
      type: Object,
      default: () => {
      }
    }
  },
  data() {
    return {
      dialogVisible: true,
      url: 'https://fuss10.elemecdn.com/e/5d/4a731a90594a4af544c0c25941171jpeg.jpeg',
    }
  },
  mounted() {

  },
  methods: {
    close() {
      this.$emit('close')
    }
  }
}
</script>
<style lang="scss">

.personnelInformation {
  display: flex;
  margin-bottom: 20px;

  &-text {
    min-width: 60px;
    font-weight: 700;
    font-size: 14px;
    color: #999999;
    margin-right: 40px;
  }

  &-name {
    font-size: 15px;
    color: #000;
  }

  &-image {
    width: 640px;
    height: 755px;
    background: #FFFFFF;
    border-radius: 4px;
  }
}

@media (max-width: 1200px) {
  .personnelInformation {
    &-image {
      width: 100%;
      height: 100%;
      border-radius: 8px;
    }
  }
  .dialog > .el-dialog {
    width: 90% !important;
  }
}

/* 自定义 el-dialog 关闭按钮的大小 */
.dialog .el-dialog__headerbtn {
  font-size: 24px; /* 调整字体大小来改变图标大小 */
}
</style>
